import uiRouter from 'angular-ui-router';
import { wastetypesDirective } from './wastetypes.directive';
import { wastetypesStore } from './wastetypes.store';

export const wastetypes = angular
  .module('wastetypes', [uiRouter])
  .config($stateProvider => {
    $stateProvider.state('app.wastetypes', {
      url: '/CustWasteTypes.aspx',
      template: '<wastetypes></wastetypes>',
      data: {
        metaTitle:
          'Rentaskip Australia | Waste type description – what you can put a skip.',
        metaDescription:
          'Waste types. Classification of the waste material to be placed in the skip. Description of general waste, heavy waste and green waste.',
        metaKeywords: 'Skip hire, waste types'
      }
    });
  })
  .directive('wastetypes', wastetypesDirective)
  .factory('wastetypesStore', wastetypesStore);



/** WEBPACK FOOTER **
 ** ./src/app/components/wastetypes/wastetypes.js
 **/